import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	({ palette, spacing, typography }) => ({
		root: {
			position: 'relative',
			'&:hover': {
				'& $deleteButton, $dragButton': {
					opacity: 1,
				},
			},
		},
		radioControl: {
			alignItems: 'flex-start',
			marginLeft: -8,
			marginTop: -2,
			marginBottom: -2,
		},
		radio: {
			marginTop: 3,
			marginBottom: -20,
		},
		checkboxControl: {
			marginLeft: -12,
			marginTop: -2,
			marginBottom: -2,
		},
		label: {
			fontSize: typography.body2.fontSize,
			padding: spacing(1.25, 0),
		},
		dragButton: {
			left: spacing(-2.65),
			color: palette.calcContrastColor(palette.scoreapp.primary, palette.background.default),
			zIndex: 10,
			opacity: 0,
			top: spacing(1.25),
			transition: 'opacity 0.15s ease',
			background: 'transparent !important',
			alignSelf: 'flex-start',
			height: 'auto',
		},
		deleteButton: {
			marginTop: -8,
			marginBottom: -20,
			color: palette.calcContrastColor(palette.scoreapp.secondary, palette.background.default),
			opacity: 0,
			transition: 'opacity 0.15s ease',
			alignSelf: 'flex-start',
		},
		deleting: {
			color: palette.calcContrastColor(palette.scoreapp.secondary, palette.background.default),
		},
	}),
	{ name: 'Questions-MultipleChoiceCheckboxes-OptionItem' },
)

export default useStyles
